module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('equip-table', {
    attrs: {
      "title": "Cabin / Outdoor",
      "title-heading": "h4",
      "site-id": this.siteId,
      "owner-id": this.ownerId,
      "site-data": _vm.siteData,
      "show-qr-code": _vm.showQrCode,
      "filter-col": "category",
      "filter-val": "Buildings"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-439df18b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/subcat/BuildingsEquipTable.vue
// module id = 1448
// module chunks = 0